function hoverSwatchHandler(group) {
  var defaultThumb,
    defaultSrc,
    swatchItemBox;
  defaultSrc = $(".product-main-slide.is-selected img").attr('srcset');
  defaultThumb = $(".product-main-slide.is-selected img").data('photoswipe-swipe-src');
  swatchItemBox = $(".product-main-slide.is-selected img");

  if(swatchItemBox.length <= 0) {
    return;
  }
    
  group.find("a").on("mouseenter", function(e) {
    var $swatch = $(this);
    // Skip "no-image.gif"
    if ($swatch.data('thumb').indexOf('no-image') >= 0 || !$swatch.data('thumb')) {
      $swatch.remove();
      return;
    }
    swatchItemBox
      .attr("src", $swatch.data('thumb'))
      .removeAttr("srcset");
    }).on("mouseleave", function(e) {
        swatchItemBox
          .attr("src", defaultThumb)
          .attr("srcset", defaultSrc);
    });
}


jQuery(document).ready(function($) {
  
  // preview swatches image on PDP
  $(".product-additions > .product-swatches").each(function(){
    hoverSwatchHandler($(this));
  });

  $(document).on('click', '.add-to-cart', function(ev) {
    
    let $this = $(this),
    product_cart_qty = $this.attr('data-product-cart-qty'),
    cart_max_limit = $this.attr('data-cart-max-limit');

    if(typeof cart_max_limit !== 'undefined' && parseInt(cart_max_limit) > 0) {
      if(parseInt(product_cart_qty) >= parseInt(cart_max_limit)) {
        ev.preventDefault();
        let msg = $this.closest('.product-single__meta').find('.max-qty-message').addClass('active');
        setTimeout(function () {
            msg.removeClass('active');
        }, 5000);
      }
    }
  });

  // Fast simon collections - check if max qty reached - both quick view and add to cart
  $(document).on('click', '.isp_add_to_cart_form .isp_add_to_cart_btn, .isp_quick_view_add_to_cart_form .isp_quick_view_add_to_cart_btn_quick_view', function(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    let btn = $(this),
    form = btn.closest('form'),
    max_qty = btn.attr('data-max-qty'),
    id = form.find('input[name="id"]');
    if(typeof max_qty !== 'undefined' && typeof id !== 'undefined') {
      $.getJSON('/cart.js', function(data) {
        if(typeof data?.items !== 'undefined') {
          let product = data.items.find(pr => pr.id == id.val())
          if(product) {
            if(parseInt(max_qty) > parseInt(product.quantity)) {
              form.submit();
            } else {
              if(btn[0] instanceof HTMLButtonElement) {
                btn.html(window.max_qty_msg_exceeded)
              } else {
                btn.val(window.max_qty_msg_exceeded)
              }
            }
          } else {
            form.submit();
          }
        }
      });
    } else {
      form.submit();
    }
  });

  // Fast simon PLP product swatches - run click on hover in order to load swatch previe
  $(document).on('mouseover', '.isp_product_color_swatch .product-color-swatch', function(){
    $(this).click();
  });



  // close opened tabs 
  $('.product-block--tab button.collapsible-trigger:not(.is-open)').on('click', function(ev,falseClick) {
    if(falseClick) {
      return
    }
    var that = this;
    setTimeout(function() {
      $('.product-block--tab button.collapsible-trigger.is-open').not(that).trigger('click', ['falseClick'])
    }, 50)
  })

  // Sticky bar
  $("#product-sticky-bar").each(function() {
    var stickyBar = $(this);

    $(window).on("load scroll resize", function() {
        if ($(window).scrollTop() > $(".product-single__form .add-to-cart").offset().top) stickyBar.show();
        else stickyBar.hide();
    });
  });
  $(document).on('click', '.btn--atc-sticky', function(e) {
    window.scrollTo(0,0);
    $(".product-single__form .add-to-cart").click();
  });


});

// Donation widget style change
(function() {
  const targetNode = document.getElementById('main-cart-dk-tipping-static');
  // Options for the observer (which mutations to observe)
  const config = { attributes: false,
    childList: true,
    subtree: false,
    characterData: false };

  // Callback function to execute when mutations are observed
  const callback = function(mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {    
          if(mutation.addedNodes.length) {
            var style = document.createElement( 'style' )
            style.innerHTML = '.dk-tipping-plugin { background: transparent !important; }'
            for(const elm of mutation.addedNodes) {
              elm.shadowRoot.appendChild( style )
            }
            observer.disconnect();
          }
        } 
      }
  };

  if(targetNode) {
    // Create an observer instance linked to the callback function
    const observers = new MutationObserver(callback);
    
    // Start observing the target node for configured mutations
    observers.observe(targetNode, config);
  }
})();




function customAddToCart(data) {
  jQuery.post(theme.routes.cartAdd, data).done(function(data) {
    if (data.status === 422) {
      console.log(data);
    } else {
      var product = data;
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product
        }
      }));
    }
    if (document.body.classList.contains('template-cart')) {
      window.scrollTo(0, 0);
      location.reload();
    }
  });

}

function customRemoveFromCart(data) {
  jQuery.post(theme.routes.cartChange, data).done(function(data) {
    if (data.status === 422) {
      console.log(data);
    } else {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          cart: data
        }
      }));
    }
    if (document.body.classList.contains('template-cart')) {
      window.scrollTo(0, 0);
       location.reload();
    }
  });

}

// fast simon - product added event
document.addEventListener('cart:build', function(evt) {
  // open theme cart drawer
  if((evt.detail && typeof evt.detail.name !== 'undefined') && evt.detail.name == 'gifts-tiers-check') {
    return;
  }
  document.dispatchEvent(new CustomEvent('ajaxProduct:added', evt));
});
